import { __assign, __awaiter, __generator } from 'tslib';
import React__default, { useEffect, useState } from 'react';
import { createScriptRun } from '@keepeek/api-client';
import { Box, Button, Typography } from '@mui/material';
import Axios from 'axios';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from '../ConfirmationDialog/index.js';
import { useLocale } from '../providers/locale/hooks.js';
import { useScripts } from '../providers/scripts/hooks.js';
import KTableContainer from './containers/KTableContainer/index.js';

var KFScriptManager = function KFScriptManager(_a) {
    var _b;
    var dataLocale = _a.dataLocale, _c = _a.testId, testId = _c === void 0 ? "KFScriptManager" : _c, className = _a.className, KIcon = _a.KIcon;
    var setDataLocale = useLocale().setDataLocale;
    useEffect(function () {
        setDataLocale({
            locale: dataLocale
        });
    }, [setDataLocale, dataLocale]);
    var _d = useScripts(), scripts = _d.scripts, loading = _d.loading, refreshScripts = _d.refreshScripts;
    var t = useTranslation("refront-components").t;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _e = useState({
        dialogOpen: false,
        script: null
    }), runScriptAction = _e[0], setRunScriptAction = _e[1];
    function handleRunScript(script) {
        setRunScriptAction(__assign(__assign({}, runScriptAction), { script: script, dialogOpen: true }));
    }
    function handleScriptRunDialog(dialogConfirmation) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!dialogConfirmation) return [3 /*break*/, 4];
                        if (!!((_a = runScriptAction.script) === null || _a === void 0 ? void 0 : _a.id)) return [3 /*break*/, 1];
                        enqueueSnackbar(t("components.kf-script-manager.script-run.error"), {
                            variant: "error"
                        });
                        return [3 /*break*/, 4];
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, createScriptRun(Axios, {
                                script: {
                                    id: runScriptAction.script.id
                                }
                            })];
                    case 2:
                        _b.sent();
                        refreshScripts();
                        enqueueSnackbar(t("components.kf-script-manager.script-run.success"), {
                            variant: "success"
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        _b.sent();
                        enqueueSnackbar(t("components.kf-script-manager.script-run.error"), {
                            variant: "error"
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        setRunScriptAction(__assign(__assign({}, runScriptAction), { dialogOpen: false }));
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React__default.createElement(Box, { className: clsx("KFScriptManager", className), "data-testid": testId },
        React__default.createElement(KTableContainer, { loading: loading, rows: scripts === null || scripts === void 0 ? void 0 : scripts.data, totalCount: scripts === null || scripts === void 0 ? void 0 : scripts.totalCount, onRunScript: handleRunScript, KIcon: KIcon }),
        React__default.createElement(ConfirmationDialog, { onClose: handleScriptRunDialog, open: runScriptAction.dialogOpen, cancelVariant: "text", okLabel: t("components.kf-script-manager.script-run.confirmation.ok.button"), cancelLabel: t("components.kf-script-manager.script-run.confirmation.cancel.button"), title: t("components.kf-script-manager.script-run.confirmation.title"), customButton: Button },
            React__default.createElement(Typography, null, t("components.kf-script-manager.delete.confirmation.body", {
                name: (_b = runScriptAction.script) === null || _b === void 0 ? void 0 : _b.title
            })))));
};

export { KFScriptManager as default };
//# sourceMappingURL=index.js.map
